import { AnchorHTMLAttributes, ReactElement, ReactNode } from "react";
import { AUTHENTICATION_STORED_ITEM, authenticationFlag } from "../../shared/utils/authentication-item.utils";
import { useStoredItem } from "../../state/InternalContext";
import { useAuth } from "../internal/AuthProvider";
import { AuthActionAnchor } from "./auth-action-anchor";

interface SignInButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    children?: ReactNode;
}

/**
 * Opens the login dialog. Renders only when `_authentication` `showLogin` is true.
 * Visibility comes from that stored item, not from AuthProvider's loading flag, so the server seed survives hydration.
 */
export function SignInButton({ children, ...anchorProps }: SignInButtonProps): ReactElement | null {
    const item = useStoredItem(AUTHENTICATION_STORED_ITEM);
    const { showLogin } = useAuth();

    if (!authenticationFlag(item, "showLogin")) {
        return null;
    }

    return (
        <AuthActionAnchor {...anchorProps} defaultLabel="Login" title="Login" onAction={showLogin}>
            {children}
        </AuthActionAnchor>
    );
}
